import { createSlice } from "@reduxjs/toolkit";

const messagesSlice = createSlice({
  name: "messages",
  initialState: {
    conversations: {},
    notifications: {},
    activeConversation: null,
  },
  reducers: {
    addMessage(state, action) {
      const { conversationId, message } = action.payload;
    
      if (!Array.isArray(state.conversations[conversationId])) {
        state.conversations[conversationId] = [];
      }
    
      state.conversations[conversationId].push(message);
    
      if (!state.activeConversation || state.activeConversation !== conversationId) {
        state.notifications[conversationId] = (state.notifications[conversationId] || 0) + 1;
      }
    },
    updateConversation(state, action) {
      const updatedConversation = action.payload;
      state.conversations = {
        ...state.conversations,
        [updatedConversation._id]: updatedConversation,
      };
    },
    addConversation(state, action) {
      const conversation = action.payload;
      state.conversations[conversation._id] = conversation;
    },
    setActiveConversation(state, action) {
      state.activeConversation = action.payload;
    },
    resetNotifications(state, action) {
      const conversationId = action.payload;
    
      // Prevent overwriting unread counts if another message is received
      if (state.activeConversation === conversationId) {
        state.notifications[conversationId] = 0;
      }
    },
    setNotifications(state, action) {
      const conversations = action.payload;
      conversations.forEach((conv) => {
        state.notifications[conv._id] = conv.unreadCount;
      });
    },
    resetMessages(state) { 
      state.conversations = {};
      state.notifications = {};
      state.activeConversation = null;
    },
  },
});

export const { addMessage, setActiveConversation, updateConversation, addConversation, resetNotifications, setNotifications, resetMessages } = messagesSlice.actions;
export default messagesSlice.reducer;